var Handlebars = require("../../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.invokePartial(require("../../channel_message_link.hbs"),undefined,{"name":"../../channel_message_link","hash":{"href":lookupProperty(depth0,"url"),"is_empty_string_topic":lookupProperty(depth0,"is_empty_string_topic"),"topic_display_name_html":lookupProperty(depth0,"topic_display_name_html"),"channel_name":lookupProperty(depth0,"channel_name"),"stream":lookupProperty(depth0,"stream")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_topic_link"),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":16,"column":4}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = container.invokePartial(require("../../topic_link.hbs"),undefined,{"name":"../../topic_link","hash":{"href":lookupProperty(depth0,"url"),"is_empty_string_topic":lookupProperty(depth0,"is_empty_string_topic"),"topic_display_name_html":lookupProperty(depth0,"topic_display_name_html"),"channel_name":lookupProperty(depth0,"channel_name"),"stream":lookupProperty(depth0,"stream"),"channel_id":lookupProperty(depth0,"channel_id")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a class=\"stream\" data-stream-id=\""
    + alias3(alias2(alias1(depth0, "channel_id", {"start":{"line":9,"column":44},"end":{"line":9,"column":54}} ), depth0))
    + "\" href=\""
    + alias3(alias2(alias1(depth0, "url", {"start":{"line":9,"column":66},"end":{"line":9,"column":69}} ), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"stream"),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":10,"column":12},"end":{"line":14,"column":21}}})) != null ? stack1 : "")
    + "</a>";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(require("../../decorated_channel_name.hbs"),undefined,{"name":"../../decorated_channel_name","hash":{"show_colored_icon":false,"inline_with_text":true,"stream":lookupProperty(depth0,"stream")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "#"
    + container.escapeExpression(container.lambda(container.strict(depth0, "channel_name", {"start":{"line":13,"column":15},"end":{"line":13,"column":27}} ), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_message_link"),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":16,"column":13}}})) != null ? stack1 : "")
    + "</li>\n";
},"usePartial":true,"useData":true});